import React, { createContext, useContext, useEffect, useState } from "react";

// Text-size steps (percent applied to the document root) shared by every
// language/accessibility control in the app — Landing's public utility bar
// and the authenticated Header widget both read/write this single state so
// a choice made on one persists across sign-in/sign-out and route changes.
export const FONT_SCALES = [87.5, 100, 112.5, 125];

const PreferencesContext = createContext(null);

export function PreferencesProvider({ children }) {
  // Marathi is the default: this is a Government of Maharashtra portal, so the
  // state language is what officers should land on. English stays one click
  // away in the language toggle.
  const [lang, setLang] = useState("mr");
  const [scaleIdx, setScaleIdx] = useState(1);

  useEffect(() => {
    document.documentElement.style.fontSize = `${FONT_SCALES[scaleIdx]}%`;
  }, [scaleIdx]);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = {
    lang,
    setLang,
    scaleIdx,
    increaseText: () => setScaleIdx((i) => Math.min(FONT_SCALES.length - 1, i + 1)),
    decreaseText: () => setScaleIdx((i) => Math.max(0, i - 1)),
  };

  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
}

export function usePreferences() {
  const ctx = useContext(PreferencesContext);
  if (!ctx) throw new Error("usePreferences must be used within a PreferencesProvider");
  return ctx;
}
